import Vue from "vue";
import Vuex from "vuex";
import order from "./order";
import error from "./error";
import productCategory from "./productCategory";
import productType from "./productType";
import office from "./office";
import auth from "./auth";
import productGroup from "./productGroup";
import product from "./product";
import TokenService from "../services/TokenService";
import attribute from "./attribute";
import department from "./department";
import contact from "./contract";
import supplier from "./supplier";
import user from "./user";
import role from "./role";
import columnTable from "@/store/columnTable";
import list from "@/store/list";
import attachment from "@/store/attachment";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    loading: false,
    errorMessage: "",
  },
  getters: {
    loading: (state) => state.loading,
  },
  mutations: {
    showLoading: (state) => (state.loading = true),
    clearLoading: (state) => (state.loading = false),
    clearUserData(state) {
      TokenService.removeToken();
      TokenService.removeRefreshToken();
      state.user.user = null;
    },
  },
  modules: {
    order,
    error,
    productType,
    office,
    productCategory,
    auth,
    productGroup,
    product,
    attribute,
    department,
    contact,
    supplier,
    user,
    role,
    columnTable,
    list,
    attachment,
  },
});
